/**
 * This function removes duplicates from an array
 */
export const uniq = (arr) => Array.from(new Set(arr));
//# sourceMappingURL=uniq.js.map